// noinspection JSValidateTypes

import React, {useEffect} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import {Button, Form, FormControl, InputGroup, Nav, Table} from "react-bootstrap";
import {useState} from "@hookstate/core";
import {formatDate, getJobCount, getJobIdByNumber, getJobs, setJobStatus, statusTypes} from "../../Services/ApiService";
import ReactPaginate from "react-paginate";

import './JobsList.scss';

function JobsList() {
    const apiError = useState(false);
    const jobs = useState([]);
    const searchQuery = useState('');
    const searchResults = useState([]);
    const showEstimates = useState(false);
    const showNotInvoicedOnly = useState(false);
    const jobNumberSearch = useState('');
    const jobNotFoundNotifShow = useState(false);
    const jobsCount = useState(0);
    const estimatesCount = useState(0);
    const currentPageNum = useState(1);
    const pageCountJobs = useState(0);
    const pageCountEstimates = useState(0);
    const history = useHistory();
    const location = useLocation();

    const jobsToShow = process.env.REACT_APP_JOBSDISPLAYED;

    useEffect(() => {
        currentPageNum.set(Number(new URLSearchParams(location.search).get('page')))
        showEstimates.set(new URLSearchParams(location.search).get('estimates') === 'true');
        showNotInvoicedOnly.set(new URLSearchParams(location.search).get('notInvoiced') === 'true');

        if (currentPageNum.get() === null || currentPageNum.get() < 1) {
            currentPageNum.set(1);
        }

        getJobCount(_counts => {
            // noinspection JSUnresolvedReference
            if (!_counts.apiError) {
                // noinspection JSUnresolvedReference
                jobsCount.set(_counts[0].num_jobs);
                // noinspection JSUnresolvedReference
                estimatesCount.set(_counts[1].num_jobs);

                // noinspection JSUnresolvedReference
                pageCountJobs.set(Math.ceil(_counts[0].num_jobs / jobsToShow));
                // noinspection JSUnresolvedReference
                pageCountEstimates.set(Math.ceil(_counts[1].num_jobs / jobsToShow));
            }
        });

        getJobs(res => {
            // noinspection JSUnresolvedReference
            apiError.set(res.apiError);

            // noinspection JSUnresolvedReference
            const _jobs = res.jobs;

            jobs.set(_jobs);
            searchResults.set(_jobs);
        }, jobsToShow, jobsToShow * (currentPageNum.get() - 1), showEstimates.get(), showNotInvoicedOnly.get());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const handleOnSearchChange = e => {
        searchQuery.set(e.target.value);
        const query = e.target.value.toLowerCase();

        if (query === '') {
            searchResults.set(JSON.parse(JSON.stringify(jobs.get())));
        } else {
            searchResults.set(jobs.get().filter(job => {
                if (job.jobNumber > 0) {
                    return job.jobNumber.toString().includes(query) ||
                        job.clientName.toLowerCase().includes(query) ||
                        job.itemInfo.toLowerCase().includes(query);
                } else {
                    return null;
                }
            }));
        }
    }


    const handlePageClick = (selectedPage) => {
        searchQuery.set('');

        let newUrl = `/jobs?page=${selectedPage.selected + 1}`;
        if (showEstimates.get()) {
            newUrl += '&estimates=true';
        }

        history.push(newUrl);
        currentPageNum.set(Number(selectedPage.selected));
    };

    function PageLinksDiv() {
        if (pageCountJobs.get() < 2) return <p></p>;

        if (!showNotInvoicedOnly.get()) {
                if (!showEstimates.get()) {
                    // noinspection JSValidateTypes
                    return <ReactPaginate
                        pageCount={pageCountJobs.get()}
                        forcePage={currentPageNum.get() - 1}
                        previousLabel={'< Prev'}
                        nextLabel={'Next >'}
                        containerClassName={'pageLinksDiv'}
                        pageLinkClassName={'pageLinks'}
                        onPageChange={handlePageClick}
                        hrefBuilder={(page) => `/jobs?page=${page}`}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        activeClassName={'activePage'}
                    />
                } else {
                    return <ReactPaginate
                        pageCount={pageCountEstimates.get()}
                        forcePage={currentPageNum.get() - 1}
                        previousLabel={'< Prev'}
                        nextLabel={'Next >'}
                        containerClassName={'pageLinksDiv'}
                        pageLinkClassName={'pageLinks'}
                        onPageChange={handlePageClick}
                        hrefBuilder={(page) => `/jobs?page=${page}`}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        activeClassName={'activePage'}
                    />
                }
            } else {
             return <p></p>
            }
        }

    function HandleShowEstimatesChecked(e) {
        showEstimates.set(e.target.checked);
        searchQuery.set('');

        let newUrl = `/jobs`;
        if (showEstimates.get()) {
            newUrl += '?estimates=true';
        }

        history.push(newUrl);
    }

    function HandleShowNotInvoicedOnlyChecked(e) {
        showNotInvoicedOnly.set(e.target.checked);
        searchQuery.set('');

        let newUrl = `/jobs`;
        if (showNotInvoicedOnly.get()) {
            newUrl += '?notInvoiced=true';
        }

        history.push(newUrl);
    }

    if (apiError.get()) {
        return <h4>Unable to reach server.</h4>;
    }

    function goToJobByNumber(e) {
        e.preventDefault();
        const uuidRegex = /.{8}\b-.{4}\b-.{4}\b-.{4}\b-.{12}/gi;

        getJobIdByNumber(jobNumberSearch.get(), _id => {
            if (_id[0] === undefined || !_id[0].id.match(uuidRegex)) {
                // job not found
                jobNotFoundNotifShow.set(true);

                setTimeout(() => {
                    jobNotFoundNotifShow.set(false);
                }, 5000)
            } else {
                history.push(`/job/${_id[0].id}`);
            }
        })
    }

    function updateJobStatus(job, status) {
        setJobStatus(status, job.id, _ => {});

        setTimeout(() => {
            getJobs(res => {
                // noinspection JSUnresolvedReference
                apiError.set(res.apiError);

                // noinspection JSUnresolvedReference
                const _jobs = res.jobs;

                jobs.set(_jobs);
                searchResults.set(_jobs);
            }, jobsToShow, jobsToShow * (currentPageNum.get() - 1), showEstimates.get());
        }, 250);
    }

    function jobStatusDiv(job, idx) {
        return <div className={'jobStatusDiv'}>
            <select className={'form-select'} id={`statusSelect-${idx}`}
                    value={job.status}
                    onChange={e => updateJobStatus(job, e.target.value, idx)}
            >
                {statusTypes.map(status => {
                    return <option key={status} value={status}>{status}</option>
                })}
            </select>
        </div>
    }

    return(
        <div id="jobsList">
            <div id={'searchBlock'}>
                <InputGroup id='search' className={'mb-3'}>
                    <InputGroup.Prepend>
                        <InputGroup.Text>Search this page</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                        id='jobSearchInput'
                        name='jobSearchInput'
                        autoComplete={'off'}
                        value={searchQuery.get()}
                        onChange={handleOnSearchChange}
                    />
                </InputGroup>
                <div id={'advancedDiv'}>
                    <a href={'/advancedSearch'} id={'advanced'}>Advanced Search</a>
                </div>
            </div>

            <div id={'secondLine'}>
                <div id={'showEstimatesDiv'}>
                    <Form.Check id={'showEstimatesCheck'}
                                onChange={e => HandleShowEstimatesChecked(e)}
                                checked={showEstimates.get()}
                                label={'Show estimates'}
                    />
                </div>

                <Form onSubmit={(e) => goToJobByNumber(e)}>
                    <InputGroup id='goToNumberInput' className={'mb-3'}>
                        <InputGroup.Prepend>
                            <InputGroup.Text>Go to Job Number</InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl
                            id='jobNumberInput'
                            name='jobNumberInput'
                            autoComplete={'off'}
                            value={jobNumberSearch.get()}
                            onChange={e => jobNumberSearch.set(e.target.value)}
                        />
                        <InputGroup.Append><Button onClick={e => goToJobByNumber(e)}>Go</Button></InputGroup.Append>
                    </InputGroup>
                    <p id={`jobNotFound-${jobNotFoundNotifShow.get()}`}>Job not found</p>
                </Form>
            </div>

            <div id={'aboveTable'}>
                {PageLinksDiv()}
                <Form.Check id={'displayNotInvoicedCheck'}
                            onChange={e => HandleShowNotInvoicedOnlyChecked(e)}
                            checked={showNotInvoicedOnly.get()}
                            label={'Filter non invoiced only'}
                />
            </div>

            {!showEstimates.get() && DisplayJobsTable()}
            {showEstimates.get() && DisplayEstimatesTable()}

            <p>Displaying {jobs.get().length} of {jobsCount.get()} jobs</p>

            {PageLinksDiv()}
        </div>
    );

    function DisplayJobsTable() {
        return <Table id='list' bordered size={'sm'}>
            <thead>
            <tr>
                <th id={'jobNumberCol'}>Job Number</th>
                <th id={'clientCol'}>Client</th>
                <th id={'quantityCol'}>Quantity</th>
                <th id={'itemsCol'}>Job Items</th>
                <th id={'dateCol'}>Date Created</th>
                <th id={'dateCol'}>Date Due</th>
                <th id={'statusCol'}>Status</th>
                <th id={'invoicedDateCol'}>Invoiced</th>
            </tr>
            </thead>
            <tbody>
            {searchResults.get().map((job, idx) => {
                if (job.id !== 'estimate0' && job.id !== 'job0') {
                    // noinspection JSUnresolvedReference
                    return (
                        <tr key={idx} className={job.status.toLocaleLowerCase() === "canceled" ? "canceledJob" : ""}>
                            <td className={'number'}>
                                <Nav.Link as={Link} to={`/job/${job.id}`}>
                                    {job.jobNumber !== -1 ? job.jobNumber + job.jobNumberAppend : "Estimate"}
                                </Nav.Link>
                            </td>
                            <td className={'client'}>
                                <Nav.Link as={Link} to={`/client/${job.clientId}`}>
                                    {job.clientName}
                                </Nav.Link>
                            </td>
                            <td className={'quantity'}>{job.quantity}</td>
                            <td className={'itemInfo'}>
                                <Nav.Link as={Link} to={`/job/${job.id}`} className={'noBlue'}>
                                    {job.itemInfo}
                                </Nav.Link>
                            </td>
                            <td className={'dateDue'}>{formatDate(job.dateReceived)}</td>
                            <td className={'dateDue'}>{formatDate(job.dateDue)}</td>
                            <td className={'status'}>{jobStatusDiv(job, idx)}</td>
                            <td className={`invoicedDate status-${job.status.toLowerCase()}`}>
                                {job.invoicedDate === null && job.jobNumber + job.jobNumberAppend}
                                {formatDate(job.invoicedDate)}
                            </td>
                        </tr>
                    )
                } else {
                    return null;
                }
            })}
            </tbody>
        </Table>
    }

    function DisplayEstimatesTable() {
        return <Table id='list' bordered size={'sm'}>
            <thead>
            <tr>
                <th id={'jobNumberCol'}>Job Number</th>
                <th id={'clientCol'}>Client</th>
                <th id={'quantityCol'}>Quantity</th>
                <th id={'itemsCol'}>Job Items</th>
                <th id={'dateCol'}>Date Created</th>
            </tr>
            </thead>
            <tbody>
            {searchResults.get().map((job, idx) => {
                if (job.id !== 'estimate0' && job.id !== 'job0') {
                    // noinspection JSUnresolvedReference
                    return (
                        <tr key={idx}>
                            <td className={'number'}>
                                <Nav.Link as={Link} to={`/job/${job.id}`}>
                                    {job.jobNumber !== -1 ? job.jobNumber + job.jobNumberAppend : "Estimate"}
                                </Nav.Link>
                            </td>
                            <td className={'client'}>
                                <Nav.Link as={Link} to={`/client/${job.clientId}`}>
                                    {job.clientName}
                                </Nav.Link>
                            </td>
                            <td className={'quantity'}>{job.quantity}</td>
                            <td className={'itemInfo'}>
                                <Nav.Link as={Link} to={`/job/${job.id}`} className={'noBlue'}>
                                    {job.itemInfo}
                                </Nav.Link>
                            </td>
                            <td className={'dateDue'}>{formatDate(job.dateReceived)}</td>
                        </tr>
                    )
                } else {
                    return null;
                }
            })}
            </tbody>
        </Table>
    }
}

export default JobsList;
